import { Component, Input, OnInit } from '@angular/core';
import { HorizontalMenuState } from './horizontal-menu.state';
import { TabItem } from './tab-item.interface';
import { Subject, takeUntil } from 'rxjs';
import { ViewConfigurationService } from 'src/domain/view-configuration';
import { QueryParamsProvider } from '@domain/routing';

@Component({
	selector: 'app-horizontal-menu',
	templateUrl: './horizontal-menu.component.html',
	styleUrls: ['./horizontal-menu.component.scss']
})
export class HorizontalMenuComponent implements OnInit {
	@Input() public tables: TabItem[];
	@Input() public isUsedInFooter: boolean;

	public activeSelection: string;
	private unsubscriber$: Subject<boolean> = new Subject<boolean>();

	public constructor(
		private horizontalMenuState: HorizontalMenuState,
		private viewConfigurationService: ViewConfigurationService,
	) {}

	public ngOnInit() {
		if (this.tables && this.tables.length > 0) {
			this.activeSelection = this.tables[0].tableName;
			this.horizontalMenuState.setActive(this.tables[0].tableName);
		}

		console.log(this.tables)

		this.horizontalMenuState.activeSelection$
			.pipe(takeUntil(this.unsubscriber$))
			.subscribe((item: string) => (this.activeSelection = item));
	}

	public segmentChanged(e: any): void {
		this.horizontalMenuState.setActive(e.detail.value);
	}

	public shouldHighlight(table: TabItem): boolean {
		return table.tableName === 'Direction';
	}
}
